import React from "react";
import classnames from "classnames";
import { startCase } from "lodash";
import IconSpinner from "components/IconSpinner";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  withArrow?: boolean;
  loading?: boolean;
  btnLabel?: string;
  btnClass?: string;
  icon?: {
    icon?: React.ReactNode;
    position?: "left" | "right";
  };
  color?:
    | "primary"
    | "secondary"
    | "red"
    | "cancel"
    | "action"
    | "dismiss"
    | "paychex"
    | "create-account";
  name: "submit" | "cancel" | "action";
  size?: string;
  ref?: React.Ref<HTMLButtonElement>;
}

const Button = React.memo(function Button({
  withArrow,
  loading = false,
  disabled = false,
  type = "submit",
  onClick,
  btnLabel = "Continue",
  children,
  size,
  btnClass,
  icon,
  color,
  name,
  ref,
  className: classNameProp,
  ...rest
}: ButtonProps) {
  const className = classnames(
    "submit-button button",
    {
      "has-arrow": withArrow,
      [`button-${color}`]: !!color,
      disabled,
      loading,
    },
    size,
    btnClass,
    classNameProp
  );

  const label = startCase(btnLabel);

  return (
    <button
      ref={ref}
      className={className}
      disabled={disabled || loading}
      name={name}
      type={type}
      onClick={onClick}
      {...rest}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        <span>
          {icon && icon.position === "left" && (
            <div
              className="btn-icon"
              style={{ paddingRight: 5, position: "relative" }}
            >
              {icon.icon}
            </div>
          )}
        </span>
        <span> {children || label}</span>
        {loading && (
          <span className="btn-loading-spinner" data-testid="icon-spinner">
            <IconSpinner size="sm" type="light" />
          </span>
        )}
        {withArrow && !loading && !disabled && (
          <span className="btn-arrow">
            <svg
              version="1.1"
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              x="0px"
              y="0px"
              viewBox="0 0 60 60"
              style={
                {
                  enableBackground: "new 0 0 60 60",
                } as React.CSSProperties
              }
            >
              <path
                className="st0"
                d="M0,30.2c0.2,1,1.1,1.7,2.1,1.7h47.5c0.7,0,1.1,0.8,0.7,1.4l-6,5.4c-0.4,0.4-0.6,0.9-0.6,1.4
c0,0.6,0.2,1.1,0.7,1.5c0.8,0.7,2,0.6,2.8-0.2l12.2-10.1c0.1-0.1,0.2-0.2,0.3-0.3l0.1-0.1c0-0.1,0.1-0.1,0.1-0.2s0-0.1,0.1-0.2
c0-0.1,0-0.1,0.1-0.2C60,30,60,29.8,60,29.5c0-0.1,0-0.1-0.1-0.2c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0,0,0-0.1-0.1-0.1
c-0.1-0.1-0.2-0.2-0.3-0.3L47,18.4c-0.7-0.7-1.8-0.9-2.6-0.3c-1,0.7-1.1,2.2-0.3,3l6.2,5.4c0.5,0.6,0,1.4-0.7,1.4H2
C0.8,27.9-0.2,29,0,30.2z"
              ></path>
            </svg>
          </span>
        )}
        <span>
          {icon && icon.position === "right" && (
            <div
              className="btn-icon"
              style={{ paddingLeft: 5, position: "relative", bottom: 1 }}
            >
              {icon.icon}
            </div>
          )}
        </span>
      </div>
    </button>
  );
});

export default Button;
